//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      reCertif: false,
      choseRoute: -1 //0:法人路线  1：经办人路线

    };
  },
  computed: {
    // 未认证过的企业或者是点击变更认的用户才能选择radio   其余置灰
    disabled: function disabled() {
      return this.enterpriseCert.basicFlag == 1;
    } // showReCertif() {
    // 	// 变更认证按钮，认证过的企业才显示
    // 	return typeof this.enterpriseCert.certType != 'undefined' && this.enterpriseCert.certType != null &&
    // 		!this.guoRuiCertStorage
    // }

  },
  watch: {
    enterpriseCert: function enterpriseCert(a, b) {
      this.choseRoute = typeof a.certType != 'undefined' && a.certType != null ? a.certType : -1;
    }
  },
  created: function created() {},
  mounted: function mounted() {
    if (this.$route.params && typeof this.$route.params.certType != 'undefined') {
      this.choseRoute = this.$route.params.certType;
      return;
    } // 回填缓存选择方式数据


    this.choseRoute = typeof this.enterpriseCert.certType != 'undefined' && this.enterpriseCert.certType != null ? this.enterpriseCert.certType : -1;
  },
  methods: {
    nextStep: function nextStep() {
      var _this = this;

      if (this.choseRoute != -1) {
        var query = {};

        if (this.choseRoute != this.enterpriseCert.certType) {
          // 暂时存缓存，更新至全局变量，使顶部步骤条变绿
          this.$confirm("由于您的选择会影响企业认证状态，继而影响平台内您的其他操作，如确认选择该认证方式请点击“确认”按钮!", '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            var data = _this.enterpriseCert;
            data['certType'] = _this.choseRoute;
            data['basicFlag'] = 0;
            data['certPhoneFlag'] = 0;
            data['signFlag'] = 0;

            _this.$store.commit('onChangeCert', data);

            _this.$router.push({
              path: "/internalSystem/certification/basicInfo",
              query: {
                edit: 1
              }
            });
          }).catch(function () {});
        } else {
          this.$router.push({
            path: "/internalSystem/certification/basicInfo"
          });
        }
      } else {
        this.$message.error('请先选择认证方式');
      }
    }
  }
};